module.exports = __webpack_public_path__ + "img/a1-2.ed500a8c.png";